import { questionSite } from '@/api/opportunity'

const registerMixin = {
    data() {
        return {
            questionVal: [],
            questionOption: []
        }
    },
    mounted() {
        this.getQuestionOption()
    },
    methods: {
        formatQuestionData(data) {
            data.forEach(item => {
                if (item.answerList || !item.leaf) {
                    item.children = item.answerList || item.subAnswerList || []
                    this.formatQuestionData(item.children)
                }
            })
            return data
        },
        getQuestionOption() {
            questionSite({
                showType: 'PRODUCT_PUBLISH'
            })
            .then(res => {
                let data = res.data.data
                if (data.questionList && data.questionList.length > 0) {
                    this.questionOption = this.formatQuestionData(data.questionList) 
                }
            })
            .finally(() => {})
        },
        questionTagChange() {
            let questionList = []
            this.questionVal.forEach(item => {
                let index = questionList.findIndex(item2 => {
                    return item2.questionId === item[0]
                })
                if (index === -1) {
                    questionList.push({
                        questionId: item[0],
                        answerIds: [item[item.length - 1]],
                        tagNames: [this.getTagName(item)]
                    })
                } else {
                    questionList[index]['answerIds'].push(item[item.length - 1])
                    questionList[index]['tagNames'].push(this.getTagName(item))
                }
            })
            this.searchQestionVal = questionList
        },
        getTagName(item) {
          const level1 = this.questionOption.find(i => {
            return i.id === item[0]
          })
          if (!level1) {
            return ''
          }
          const level2 = level1.children.find(i => {
            return i.id === item[1]
          })
          return `${level1.name}:${level2.name}`
        },
    }
}
export default registerMixin